import { CashAccountModel } from 'api-hooks/cash-account';
import * as Yup from 'yup';

export const CashAccountFormSchema = () =>
  Yup.object({
    code: Yup.string().default('').required(),
    name: Yup.string().default('').required(),
    description: Yup.string().default(''),
    balance: Yup.number().default(0),
  });

export type CashAccountFormType = {
  code: string;
  name: string;
  description: string;
  balance: number;
  cashAccount?: CashAccountModel;
};
